<template>
  <div :class="divWidthChange" class="conteudoWidth">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>

    <fccTable
      striped
      hover
      :fields="configTableGerencAgenda.fields"
      :status="configTableGerencAgenda.status"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      fieldVisibility
      pdf
      csv
      xls
      :titlePage="titlePage"
      :titlePDF="titlePage"
      :actions="configTableGerencAgenda.actions"
      addFilter
      :items="listaAgenda"
    />

    <fcc-modal
      centered
      id-modal="modal-agenda"
      :title-modal="titleModalSituacao"
      esconde-footer
      trava-esc
      trava-back
    >
      <b-form @submit.prevent="submitModalAgenda" autocomplete="off">
        <div class="row">
          <div class="col-md-12">
            <fcc-select
              class="mb-4"
              placeholder="Selecione uma fila"
              labelField="fildescricao"
              valueField="filid"
              v-model="itemAgenda.filid"
              :options="listaFilas"
              required
            >
              Fila
            </fcc-select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <fcc-select
              class="mb-4"
              placeholder="Selecione um dia da semana"
              labelField="descricao"
              valueField="value"
              v-model="itemAgenda.filagediasemana"
              :options="diasSemana"
              required
            >
              Dia da semana
            </fcc-select>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-md-6">
            <fccDateInput
              id="filagehorainicio"
              type="time"
              v-model="itemAgenda.filagehorainicio"
              min-datetime="today"
              required
              >Hora inicial</fccDateInput
            >
          </div>
          <div class="col-md-6">
            <fccDateInput
              id="filagehorafim"
              type="time"
              v-model="itemAgenda.filagehorafim"
              :min-datetime="itemAgenda.filagehorainicio"
              required
              >Hora final</fccDateInput
            >
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </b-form>
    </fcc-modal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      titlePage: 'Agenda',
      itemPorPage: '100',
      listaAgenda: [],
      listaFilas: [],
      diasSemana: [
        { value: 1, descricao: 'Domingo' },
        { value: 2, descricao: 'Segunda-Feira' },
        { value: 3, descricao: 'Terça-Feira' },
        { value: 4, descricao: 'Quarta-Feira' },
        { value: 5, descricao: 'Quinta-Feira' },
        { value: 6, descricao: 'Sexta-Feira' },
        { value: 7, descricao: 'Sábado' }
      ],
      itemAgenda: {
        filsageid: 0,
        filagediasemana: 0,
        filagehorainicio: '',
        filagehorafim: '',
        filid: 0
      },

      configTableGerencAgenda: {
        fields: [
          { key: 'filsageid', label: 'ID', sortable: true, active: true },
          {
            key: 'fila',
            label: 'Fila',
            sortable: true,
            active: true,
            type: 'sub',
            sub: { sub1: 'fila', sub2: 'fildescricao' }
          },
          {
            key: 'filagediasemana',
            label: 'Dia da semana',
            sortable: true,
            active: true,
            formatter(data) {
              if (data != '') {
                switch (data) {
                  case 1:
                    return data + ' - Domingo'
                  case 2:
                    return data + ' - Segunda-Feira'
                  case 3:
                    return data + ' - Terça-Feira'
                  case 4:
                    return data + ' - Quarta-Feira'
                  case 5:
                    return data + ' - Quinta-Feira'
                  case 6:
                    return data + ' - Sexta-Feira'
                  case 7:
                    return data + ' - Sábado'
                  default:
                    return ''
                }
              }
              return data
            }
          },

          { key: 'filagehorainicio', label: 'Hora inicial', sortable: true, active: true },
          { key: 'filagehorafim', label: 'Hora final', sortable: true, active: true },
          { key: 'actions', label: '', thClass: 'no-print', tdClass: 'text-nowrap no-print' }
        ],
        actions: [
          {
            button: true,
            funcaoButton: this.editarFilas,
            icon: 'edit',
            tooltip: 'Editar',
            objpermCodigo: store.state.permissaoMenu.editar
          },
          {
            button: true,
            funcaoButton: this.deletarFilas,
            icon: 'trash-alt',
            tooltip: 'Excluir',
            objpermCodigo: store.state.permissaoMenu.excluir
          }
        ],
        status: [
          {
            funcaoButton: this.editarFilas,
            tooltip: 'Alterar Parâmetros',
            campoStatus: 'ativo',
            objpermCodigo: store.state.permissaoMenu.editar
          }
        ]
      }
    }
  },

  methods: {
    getDadosGerencFilasAgenda: function () {
      this.carregaTexto(this.codeMensagem('C01'))

      Promise.all([
        axios.get(
          store.state.baseUrlTransferenciaArquivos + 'FilaAgenda/ListarFilaAgenda',
          this.dadosLoginSession.fccTokenHeaders
        ),
        axios.get(
          store.state.baseUrlTransferenciaArquivos + 'Fila/ListarFila',
          this.dadosLoginSession.fccTokenHeaders
        )
      ])
        .then((response) => {
          this.listaAgenda = response[0].data
          this.listaFilas = response[1].data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },

    addField() {
      this.itemAgenda = {
        filsageid: 0,
        filagediasemana: 0,
        filagehorainicio: '',
        filagehorafim: '',
        filid: 0
      }
      this.$bvModal.show('modal-agenda')
    },

    editarFilas(_, item) {
      this.itemAgenda = { ...item }
      this.$bvModal.show('modal-agenda')
    },

    deletarFilas(_, item) {
      this.callConfirm(this.mensagemExcluir, '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C02'))

          axios
            .delete(
              store.state.baseUrlTransferenciaArquivos +
                'FilaAgenda/ExcluirFilaAgenda/' +
                item.filsageid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.callToast(this.mensagensUpdate.excluido)
              this.getDadosGerencFilasAgenda()
            })
            .catch(this.setErrorSystem)
            .finally(this.carregaTexto)
        }
      })
    },

    submitModalAgenda() {
      this.carregaTexto(this.codeMensagem('C03'))

      const novoRegistro = this.itemAgenda.filsageid == null || this.itemAgenda.filsageid == 0
      let request

      if (novoRegistro) {
        request = axios.post(
          store.state.baseUrlTransferenciaArquivos + 'FilaAgenda/AdicionarFilaAgenda',
          this.itemAgenda,
          this.dadosLoginSession.fccTokenHeaders
        )
      } else {
        request = axios.put(
          store.state.baseUrlTransferenciaArquivos + 'FilaAgenda/AlterarFilaAgenda',
          this.itemAgenda,
          this.dadosLoginSession.fccTokenHeaders
        )
      }

      request
        .then(() => {
          this.getDadosGerencFilasAgenda()
          this.$bvModal.hide('modal-agenda')
          this.callToast(
            novoRegistro ? this.mensagensUpdate.adicionado : this.mensagensUpdate.editado,
            'success'
          )
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },

  computed: {
    titleModalSituacao() {
      return this.itemAgenda.filsageid != null && this.itemAgenda.filsageid != 0
        ? 'Editar Parâmetros'
        : 'Adicionar Parâmetros'
    }
  },

  created() {
    this.getDadosGerencFilasAgenda()
  }
}
</script>
